import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_ALL_TOOLBOXES = restRequest(
    "VRCORE.JOB_PACK_WIDGETS.JOB_PACK_TOOLBOX_TALK.GET_ALL_TOOLBOXES"
);
export const GET_DEPARTMENTS = restRequest(
    "VRCORE.JOB_PACK_WIDGETS.JOB_PACK_TOOLBOX_TALK.GET_DEPARTMENTS"
);
export const GET_AREAS = restRequest(
    "VRCORE.JOB_PACK_WIDGETS.JOB_PACK_TOOLBOX_TALK.GET_AREAS"
);
